import React, { Component } from "react";
import { Grid, Box, CardContent, CardMedia } from "@mui/material";
import CtBtn from "./CustomTool/CtBtn";
import CtDtp from "./CustomTool/CtDtp";
import { connect } from "react-redux";
import {
  mapStatetoProps,
  mapSetActiveMenuToProps,
} from "../mapRedux/mapReduxProps";
import { withRouter } from "../HOC/withRouter";
import HOCVerifyIsUser from "../HOC/HOCVerifyIsUser";
import HoCtToastContainer from "../HOC/HoCtToastContainer";
import TextField from "@mui/material/TextField";
import Autocomplete from "@mui/material/Autocomplete";
import { type } from "@testing-library/user-event/dist/type";
import Checkbox from "@mui/material/Checkbox";
import CtCmbEditable from "./CustomTool/CtCmbEditable";
import {
  get_YMD_from_SYS,
  validatedate_min_max,
  get_30DaysBack_FromCurrentDate,
  isValidItem,
  applyTrimOnObjectValues,
  getRoundOff,
  getString_or_Blank4Null,
  getlocalstoragedate,
  setlocalstoragedate,
} from "../SystemUtility/SystemUtility";
import FormControlLabel from "@mui/material/FormControlLabel";
import {
  apiURL,
  fetchItemMaster,
  fetchStockDetail,
  fetchStoreMaster,
} from "./API";
import ResetDate from "../images/resetdate.png";

class StockReport extends Component {
  state = {
    formData: {
      dtpFromDate: "",
      dtpToDate: "",
      cmbType: "Summary",
      cmbStoreName: "",
      cmbItemName: "",
      cmbUnit: "",
      chekNewpage: false,
    },
    types: [{ type: "Summary" }, { type: "Detail" }],
    stores: [],
    items: [],
  };
  //#region Component
  componentDidMount() {
    document.title = "RiTe Account : Stock Report";
    this.props.setActiveMenu("StockReport");
    this.props.verifyUserID(
      this.onFormLoad,
      this.props.navInfo.subMenuMaster,
      this.props.setSubMenu_Master_Entry,
      this.props.setUserPrivileges
    );
  }
  //#endregion Component

  //#region Handles
  handleOnChange = (e) => {
    this.setState(
      {
        formData: {
          ...this.state.formData,
          [e.target.name]: e.target.value,
        },
      },
      () => {
        if (e.target.name === "cmbItemName") {
          if (this.state.formData.cmbItemName === "") {
            this.setState({
              formData: {
                ...this.state.formData,
                chekNewpage: false,
              },
            });
          }
        } else if (
          e.target.name === "dtpFromDate" ||
          e.target.name === "dtpToDate"
        ) {
          this.setfrom_todate();
        }
      }
    );
  };

  handleOnCheckChange = (e) => {
    this.setState({
      formData: {
        ...this.state.formData,
        [e.target.name]: e.target.checked,
      },
    });
  };
  //#endregion Handles

  //#region Function
  getCmbType4BE(ReportType) {
    if (ReportType === "Summary") {
      return "Summary";
    } else if (ReportType === "Detail") {
      return "Detail";
    }
  }

  reqDataForReport = (bolChkDataExist) => {
    return {
      Op: "StockReport",
      bint_acid: localStorage.getItem("acid"),
      bint_acyear: localStorage.getItem("ACY"),
      dat_fromdate: this.state.formData.dtpFromDate,
      dat_todate: this.state.formData.dtpToDate,
      ReportType: this.getCmbType4BE(this.state.formData.cmbType),
      vac_storename: this.state.formData.cmbStoreName,
      vac_itemname: this.state.formData.cmbItemName,
      vac_unit: this.state.formData.cmbUnit,
      int_CustomerWisePage: this.state.formData.chekNewpage === true ? 1 : 0,
      bolChkDataExist: bolChkDataExist,
    };
  };

  trimFormData = (nextFunctionCall) => {
    let formData = applyTrimOnObjectValues({
      formData: this.state.formData,
    });
    this.setState({ formData }, () => {
      if (nextFunctionCall) {
        nextFunctionCall();
      }
    });
  };

  validateFromToDate = () => {
    let result = false;
    const fromDate = this.state.formData.dtpFromDate;
    const toDate = this.state.formData.dtpToDate;
    if (this.state.formData.dtpFromDate.length <= 0) {
      this.props.toastErrorMsg("Enter Date", "dtpFromDate");
    } else if (
      validatedate_min_max(
        this.state.formData.dtpFromDate,
        "dtpFromDate",
        this.props.toastErrorMsg
      ) == false
    ) {
      return result;
    } else if (this.state.formData.dtpToDate.length <= 0) {
      this.props.toastErrorMsg("Enter Date", "dtpToDate");
    } else if (
      validatedate_min_max(
        this.state.formData.dtpToDate,
        "dtpToDate",
        this.props.toastErrorMsg
      ) == false
    ) {
      return result;
    } else if (new Date(fromDate) > new Date(toDate)) {
      this.props.toastErrorMsg(
        "To Date must be greater than From Date",
        "dtpFromDate"
      );
    } else if (this.state.formData.cmbType.length <= 0) {
      this.props.toastErrorMsg("Select Type", "cmbType");
    } else if (
      !isValidItem(this.state.types, "type", this.state.formData.cmbType)
    ) {
      this.props.toastErrorMsg("Select Valid Type", "cmbType");
    } else if (
      this.state.formData.cmbStoreName.length > 0 &&
      !isValidItem(
        this.state.stores,
        "vac_storename",
        this.state.formData.cmbStoreName
      )
    ) {
      this.props.toastErrorMsg("Select Valid Store Name", "cmbStoreName");
    } else if (
      this.state.formData.cmbItemName.length > 0 &&
      !isValidItem(
        this.state.items,
        "vac_itemname",
        this.state.formData.cmbItemName
      )
    ) {
      this.props.toastErrorMsg("Select Valid Item Name", "cmbItemName");
    } else if (
      this.state.formData.cmbUnit.length > 0 &&
      !isValidItem(this.state.items, "vac_unit", this.state.formData.cmbUnit)
    ) {
      this.props.toastErrorMsg("Select Valid Unit", "cmbUnit");
    } else {
      result = true;
    }
    return result;
  };

  openStockReport = () => {
    if (this.validateFromToDate()) {
      this.props.notifyProcessing();
      // let reqData = this.reqDataForReport(false);
      // let params = new URLSearchParams(reqData);
      // let popupURL = apiURL + "stockbalancedetail.php?" + params.toString();
      // window.open(
      //   popupURL,
      //   "DayBookReport",
      //   "width=" +
      //     window.screen.availWidth +
      //     ",height=" +
      //     window.screen.availHeight
      // );
      // this.props.updateProcessing("success", "PDF Open in popup.");

      let reqData = this.reqDataForReport(true);
      fetchStockDetail(reqData)
        .then((res) => {
          if (res.data.msgType === "info") {
            let reqData = this.reqDataForReport(false);
            let params = new URLSearchParams(reqData);
            let popupURL =
              apiURL + "stockbalancedetail.php?" + params.toString();
            window.open(
              popupURL,
              "DayBookReport",
              "width=" +
                window.screen.availWidth +
                ",height=" +
                window.screen.availHeight
            );
            this.props.updateProcessing("success", "PDF Open in popup.");
          } else {
            this.props.updateProcessing(res.data.msgType, res.data.message);
          }
        })
        .catch((error) => {
          console.log("Unknown error occurred in openDayBookReport.", error);
          this.props.updateProcessing(
            "error",
            "Unknown error occurred in loading . " + error
          );
        });
      document.getElementById("cmbType").focus();
    }
  };

  setfrom_todate = (reset = false) => {
    setlocalstoragedate(
      "StockReport",
      this.state.formData.dtpFromDate,
      this.state.formData.dtpToDate,
      reset
    );
    if (reset) {
      // window.location.reload();
      this.onFormLoad(reset);
      document.getElementById("dtpFromDate").focus();
    }
  };

  onFormLoad = (reset = false) => {
    const { fromdate, todate } = getlocalstoragedate("StockReport");
    let dtpFromDate = fromdate,
      dtpToDate = todate;
    this.setState(
      {
        formData: {
          ...this.state.formData,
          dtpFromDate,
          dtpToDate,
        },
      },
      () => {
        if (reset) {
          this.loadItemList();
        } else {
          document.getElementById("cmbType").focus();
        }
      }
    );
  };

  loadItemList = () => {
    this.props.notifyProcessing();
    const reqData = {
      Op: "ItemList",
      bint_acid: localStorage.getItem("acid"),
      bolLoadStoreList: true,
    };
    fetchItemMaster(reqData)
      .then((res) => {
        this.props.closeUpdateProcessing(res.data.msgType, res.data.message);
        this.setState({
          items: res.data.ItemList,
          stores: res.data.StoreList,
        });
      })
      .catch((err) => {
        console.log("Unknown error occurred in getInfo.", err);
        this.props.updateProcessing(
          "error",
          "Unknown error occurred in loading . " + err
        );
      });
  };

  // loadStoreList = () => {
  //   this.props.notifyProcessing();
  //   const reqData = {
  //     Op: "StoreList",
  //     bint_acid: localStorage.getItem("acid"),
  //   };
  //   fetchStoreMaster(reqData)
  //     .then((res) => {
  //       this.props.closeUpdateProcessing(res.data.msgType, res.data.message);
  //       this.setState({ stores: res.data.StoreList });
  //     })
  //     .catch((err) => {
  //       console.log("Unknown error occurred in getInfo.", err);
  //       this.props.updateProcessing(
  //         "error",
  //         "Unknown error occurred in loading . " + err
  //       );
  //     });
  // };
  //#endregion Function

  render() {
    return (
      <form>
        {/* <Grid
          container
          direction="row"
          justifyContent="center"
          alignItems="center"
          className="title"
        >
          <label htmlFor="Title" style={{ fontSize: "25px", color: "#6f7689" }}>
            <b>Stock Report</b>
          </label>
        </Grid> */}
        <Grid
          container
          direction="row"
          justifyContent="center"
          alignItems="center"
          spacing={3}
          marginTop={0}
        >
          <Grid item>
            <CtCmbEditable
              id="cmbType"
              label="Type"
              items={this.state.types}
              colID="type"
              value={this.state.formData.cmbType}
              handleOnChange={this.handleOnChange}
              width={140}
              maxLength={50}
              onKeyDown={this.props.onKeyDown}
              nextCtrlID="dtpFromDate"
            />
          </Grid>
          <Grid item style={{ display: "inline-flex" }}>
            <CardContent style={{ paddingBottom: "0px" }}>
              <CardMedia
                component="img"
                alt="Reset Date to Default"
                sx={{ width: 35 }}
                image={ResetDate}
                onClick={() => {
                  this.setfrom_todate(true);
                }}
              />
            </CardContent>
            <CtDtp
              id="dtpFromDate"
              label="From Date"
              width="140"
              handleOnChange={this.handleOnChange}
              defaultValue={this.state.formData.dtpFromDate}
              value={this.state.formData.dtpFromDate}
              onKeyDown={this.props.onKeyDown}
              nextCtrlID="dtpToDate"
              accountYear={localStorage.getItem("ACY")}
            />
          </Grid>
          <Grid item>
            <CtDtp
              id="dtpToDate"
              label="To Date"
              width="140"
              handleOnChange={this.handleOnChange}
              defaultValue={this.state.formData.dtpToDate}
              value={this.state.formData.dtpToDate}
              onKeyDown={this.props.onKeyDown}
              nextCtrlID="cmbStoreName"
              accountYear={localStorage.getItem("ACY")}
            />
          </Grid>
          <Grid item>
            <CtCmbEditable
              id="cmbStoreName"
              label="Store Name"
              items={this.state.stores}
              colID="vac_storename"
              width={250}
              value={this.state.formData.cmbStoreName}
              handleOnChange={this.handleOnChange}
              maxLength={50}
              onKeyDown={this.props.onKeyDown}
              nextCtrlID="cmbItemName"
            />
          </Grid>
        </Grid>
        <Grid
          container
          direction="row"
          justifyContent="center"
          alignItems="center"
          spacing={3}
          marginTop={0}
        >
          <Grid item>
            <CtCmbEditable
              id="cmbItemName"
              label="Item Name"
              items={this.state.items}
              colID="vac_itemname"
              width={250}
              value={this.state.formData.cmbItemName}
              handleOnChange={this.handleOnChange}
              maxLength={50}
              onKeyDown={this.props.onKeyDown}
              nextCtrlID="cmbUnit"
            />
          </Grid>
          <Grid item>
            <CtCmbEditable
              id="cmbUnit"
              label="Unit"
              items={this.state.items}
              colID="vac_unit"
              width={150}
              value={this.state.formData.cmbUnit}
              handleOnChange={this.handleOnChange}
              maxLength={50}
              onKeyDown={this.props.onKeyDown}
              dataFilter={[
                {
                  filterColID: "vac_itemname",
                  value: this.state.formData.cmbItemName,
                },
              ]}
            />
          </Grid>
          <Grid item>
            <CtBtn
              label="PDF"
              onClick={() => {
                this.trimFormData(() => {
                  this.openStockReport();
                });
              }}
            />
          </Grid>
        </Grid>
      </form>
    );
  }
}

export default connect(
  mapStatetoProps,
  mapSetActiveMenuToProps
)(HOCVerifyIsUser(HoCtToastContainer(withRouter(StockReport))));
